import "./App.css";
import { useAbility } from "@casl/react";
import { homePath } from "./rbac/homePath";
import { useEffect, useState } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
// Components
import withClearCache from './ClearCache'
import Layout from "./pages/Layout";
import Authorization from "./components/Authorization";

// Pages
import Login from "./pages/Login";
import Logout from "./pages/Logout";
import Admin from "./pages/Admin";

import DailyFigures from "./pages/protected/dailyfigures/DailyFigures";
import DailyFigure from "./pages/protected/dailyfigures/DailyFigure";
import PendingFigures from "./pages/protected/dailyfigures/PendingFigures";
import AddFigure from "./pages/protected/dailyfigures/AddFigure";
import EditFigure from "./pages/protected/dailyfigures/EditFigure";
import Handicappers from "./pages/protected/handicappers/Handicappers";
import Handicapper from "./pages/protected/handicappers/Handicapper";
import HandicapperInsights from "./pages/protected/handicappers/HandicapperInsights";
import Accounts from "./pages/protected/accounts/Accounts";
import AddAccount from "./pages/protected/accounts/AddAccount";
import EditAccount from "./pages/protected/accounts/EditAccount";
import AccountBalance from "./pages/protected/accountbalance/AccountBalance";
import { novigAccounts, antNovigAccounts } from "./pages/protected/novigbalances/novigAccounts";
import BalancesOverview from "./pages/protected/novigbalances/BalancesOverview";
import { balanceName } from "./pages/protected/novigbalances/balanceOverviewModel";
import NovigBalances from "./pages/protected/novigbalances/NovigBalances";
import LiveFeed from "./pages/protected/livefeed/LiveFeed";
import Tools from "./pages/protected/tools/Tools";
import WnbaModels from "./pages/protected/wnbamodels/WnbaModels";
import LolPregame from "./pages/protected/lol/LolPregame";

// Arbitrage
import ArbitrageBets from "./pages/protected/arbitragebets/ArbitrageBets";

// Managers, Bettors, Agents and Bets
import Managers from "./pages/protected/managers/Managers";
import AddManager from "./pages/protected/managers/AddManager";
import EditManager from "./pages/protected/managers/EditManager";
import Bettors from "./pages/protected/bettors/Bettors";
import AddBettor from "./pages/protected/bettors/AddBettor";
import EditBettor from "./pages/protected/bettors/EditBettor";
import Agents from "./pages/protected/agents/Agents";
import AddAgent from "./pages/protected/agents/AddAgent";
import EditAgent from "./pages/protected/agents/EditAgent";
import Bets from "./pages/protected/bets/Bets";
import AddBet from "./pages/protected/bets/AddBet";
import EditBet from "./pages/protected/bets/EditBet";

// RBAC
import { AbilityContext } from './rbac/Can'
import ability from './rbac/Ability'



const ClearCacheComponent = withClearCache(MainApp);

function App() {
  return <ClearCacheComponent />;
}

function HomeRedirect() { const currentAbility = useAbility(AbilityContext); return <Navigate to={homePath(currentAbility)} replace />; }

function MainApp(props) {
  
  useEffect(() => {
    const abortController = new AbortController();
    return () => abortController.abort();
  }, []);

  return (
    <AbilityContext.Provider value={ability}>
      <Routes>
      <Route path="/" element={<Layout />}>
        <Route path="login" element={<Login />} />
        <Route path="logout" element={<Logout />} />
        <Route path="admin" element={<Admin />}>
          <Route index element={<HomeRedirect />} />
          <Route path="dashboard" element={<HomeRedirect />} />

          <Route path="daily-figures" element={<Authorization action="view" subject="daily-figures"><DailyFigures /></Authorization>} />
          <Route path="daily-figures/pending" element={<Authorization action="view" subject="daily-figures"><PendingFigures /></Authorization>} />
          <Route path="daily-figure/add" element={<Authorization action="create" subject="daily-figures"><AddFigure /></Authorization>} />
          <Route path="daily-figures/edit/:id" element={<Authorization action="update" subject="daily-figures"><EditFigure /></Authorization>} />
          <Route path="daily-figures/:id" element={<Authorization action="view" subject="daily-figures"><DailyFigure /></Authorization>} />
          
          <Route path="handicappers" element={<Authorization action="view" subject="handicappers"><Handicappers /></Authorization>} />
          <Route path="handicappers/insights" element={<Authorization action="view" subject="handicappers"><HandicapperInsights /></Authorization>} />
          <Route path="handicappers/:id" element={<Authorization action="view" subject="handicappers"><Handicapper /></Authorization>} />
          
          <Route path="accounts" element={<Authorization action="view" subject="accounts"><Accounts /></Authorization>} />
          <Route path="accounts/add" element={<Authorization action="create" subject="accounts"><AddAccount /></Authorization>} />
          <Route path="accounts/edit/:id" element={<Authorization action="update" subject="accounts"><EditAccount /></Authorization>} />

          <Route path="account-balance" element={<Authorization action="view" subject="account-balance"><AccountBalance /></Authorization>} />
          <Route path="balances-overview" element={<Authorization action="view" subject="balances"><BalancesOverview /></Authorization>} />
          <Route path="novig-balances" element={<Navigate to="/admin/novig-balances/main-wallet" replace />} />
          {novigAccounts.map(account => <Route key={account.id} path={`novig-balances/${account.slug}`} element={<Authorization action="view" subject="balances"><NovigBalances key={account.id} provider="novig" title={account.name} accountId={account.id} /></Authorization>} />)}

          <Route path="ant-novig-balances" element={<Navigate to="/admin/ant-novig-balances/arb" replace />} />
          {antNovigAccounts.map(account => <Route key={account.id} path={`ant-novig-balances/${account.slug}`} element={<Authorization action="view" subject="balances"><NovigBalances key={account.id} provider="ant-novig" title={account.name} accountId={account.id} /></Authorization>} />)}
          <Route path="prophetx-balances" element={<Authorization action="view" subject="balances"><NovigBalances key="prophetx" provider="prophetx" title={balanceName('prophetx')} /></Authorization>} />
          <Route path="kalshi-balances" element={<Authorization action="view" subject="balances"><NovigBalances key="kalshi" provider="kalshi" title={balanceName('kalshi')} /></Authorization>} />

          <Route path="polyus-dk-balances" element={<Authorization action="view" subject="balances"><NovigBalances key="polyus-dk" provider="polyus-dk" title={balanceName('polyus-dk')} /></Authorization>} />
          <Route path="greg-polyus-balances" element={<Authorization action="view" subject="balances"><NovigBalances key="greg-polyus" provider="greg-polyus" title={balanceName('greg-polyus')} /></Authorization>} />
          <Route path="ant-polyus-inst-balances" element={<Authorization action="view" subject="balances"><NovigBalances key="ant-polyus-inst" provider="ant-polyus-inst" title={balanceName('ant-polyus-inst')} /></Authorization>} />
          <Route path="sonya-prophetx-balances" element={<Authorization action="view" subject="balances"><NovigBalances key="sonya-prophetx" provider="sonya-prophetx" title={balanceName('sonya-prophetx')} /></Authorization>} />
          <Route path="ant-prophetx-balances" element={<Authorization action="view" subject="balances"><NovigBalances key="ant-prophetx" provider="ant-prophetx" title={balanceName('ant-prophetx')} /></Authorization>} />
          <Route path="yan-prophetx-balances" element={<Authorization action="view" subject="balances"><NovigBalances key="yan-prophetx" provider="yan-prophetx" title={balanceName('yan-prophetx')} /></Authorization>} />
          <Route path="polymarket-dk-mm-balances" element={<Authorization action="view" subject="balances"><NovigBalances key="polymarket-dk-mm" provider="polymarket-dk-mm" title={balanceName('polymarket-dk-mm')} /></Authorization>} />
          <Route path="polymarket-carlos-matt-ct-balances" element={<Authorization action="view" subject="balances"><NovigBalances key="polymarket-carlos-matt-ct" provider="polymarket-carlos-matt-ct" title={balanceName('polymarket-carlos-matt-ct')} /></Authorization>} />
          <Route path="polymarket-carlos-arb-balances" element={<Authorization action="view" subject="balances"><NovigBalances key="polymarket-carlos-arb" provider="polymarket-carlos-arb" title={balanceName('polymarket-carlos-arb')} /></Authorization>} />
          <Route path="polymarket-carlos-fido-ct-balances" element={<Authorization action="view" subject="balances"><NovigBalances key="polymarket-carlos-fido-ct" provider="polymarket-carlos-fido-ct" title={balanceName('polymarket-carlos-fido-ct')} /></Authorization>} />
          <Route path="a2-kalshi-balances" element={<Authorization action="view" subject="balances"><NovigBalances key="a2-kalshi" provider="a2-kalshi" title={balanceName('a2-kalshi')} /></Authorization>} />
          <Route path="eddy-kalshi-balances" element={<Authorization action="view" subject="balances"><NovigBalances key="eddy-kalshi" provider="eddy-kalshi" title={balanceName('eddy-kalshi')} /></Authorization>} />
          <Route path="yan-kalshi-balances" element={<Authorization action="view" subject="balances"><NovigBalances key="yan-kalshi" provider="yan-kalshi" title={balanceName('yan-kalshi')} /></Authorization>} />
          <Route path="greg-kalshi-balances" element={<Authorization action="view" subject="balances"><NovigBalances key="greg-kalshi" provider="greg-kalshi" title={balanceName('greg-kalshi')} /></Authorization>} />
          <Route path="ant-kalshi-balances" element={<Authorization action="view" subject="balances"><NovigBalances key="ant-kalshi" provider="ant-kalshi" title={balanceName('ant-kalshi')} /></Authorization>} />

          <Route path="polyus-fido-ct-balances" element={<Authorization action="view" subject="balances"><NovigBalances key="polyus-fido-ct" provider="polyus-fido-ct" title={balanceName('polyus-fido-ct')} /></Authorization>} />

          <Route path="live-feed" element={<Authorization action="view" subject="live-feed"><LiveFeed /></Authorization>} />

          <Route path="tools" element={<Authorization action="view" subject="tools"><Tools /></Authorization>} />

          <Route path="wnba-models" element={<Authorization action="view" subject="wnba-models"><WnbaModels /></Authorization>} />

          <Route path="lol" element={<Authorization action="view" subject="live-feed"><LolPregame /></Authorization>} />
          
          
          <Route path="arbitrage-bets" element={<Authorization action="view" subject="arbitrage-bets"><ArbitrageBets /></Authorization>} />
          
          <Route path="managers" element={<Authorization action="view" subject="managers"><Managers /></Authorization>} />
          <Route path="managers/add" element={<Authorization action="create" subject="managers"><AddManager /></Authorization>} />
          <Route path="managers/edit/:id" element={<Authorization action="update" subject="managers"><EditManager /></Authorization>} />

          <Route path="bettors" element={<Authorization action="view" subject="bettors"><Bettors /></Authorization>} />
          <Route path="bettors/add" element={<Authorization action="create" subject="bettors"><AddBettor /></Authorization>} />
          <Route path="bettors/edit/:id" element={<Authorization action="update" subject="bettors"><EditBettor /></Authorization>} />

          <Route path="agents" element={<Authorization action="view" subject="agents"><Agents /></Authorization>} />
          <Route path="agents/add" element={<Authorization action="create" subject="agents"><AddAgent /></Authorization>} />
          <Route path="agents/edit/:id" element={<Authorization action="update" subject="agents"><EditAgent /></Authorization>} />

          <Route path="bets" element={<Authorization action="view" subject="bets"><Bets /></Authorization>} />
          <Route path="bets/add" element={<Authorization action="create" subject="bets"><AddBet /></Authorization>} />
          <Route path="bets/edit/:id" element={<Authorization action="update" subject="bets"><EditBet /></Authorization>} />


        </Route>
        <Route path="" element={<HomeRedirect />} />
      </Route>
    </Routes>
    </AbilityContext.Provider>
    
  );
}

export default App;
